module.exports = __webpack_public_path__ + "static/musicmood-d166028959fc4e2b04f9fd5cf85340c5.png";